export const FIELD_TYPE = {
    FREE_TEXT: 'FREE_TEXT',
    DROPDOWN: 'DROPDOWN',
    SEARCHABLE: 'SEARCHABLE'
}

export const MU_OPTIONS = [
    {
        id: 1,
        text: 'Add to all items - Selected invoice(s)',
        text_nl: 'Toevoegen aan alle artikelen - Geselecteerde factuur(en)',
        text_es: 'Añadir a todos los artículos - Factura(s) seleccionada(s)',
        value: '1'
    },
    {
        id: 2,
        text: 'Add to all items - All invoices',
        text_nl: 'Toevoegen aan alle items - Alle facturen',
        text_es: 'Añadir a todos los artículos - Todas las facturas',
        value: '2'
    },
    {
        id: 3,
        text: 'Add to specific line items',
        text_nl: 'Toevoegen aan specifieke regelitems',
        text_es: 'Añadir a líneas de pedido específicas',
        value: '3'
    }
]